import React, { memo } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import {
  isSafeChatLinkHref,
  prepareChatMarkdownForRender,
} from "../../chatMarkdownUtils";

const ALLOWED_ELEMENTS = ["p", "strong", "em", "del", "s", "a", "br"];

const markdownComponents = {
  p: ({ children }) => (
    <span className="message-row__text-paragraph">{children}</span>
  ),
  a: ({ href, children }) => {
    if (!isSafeChatLinkHref(href)) {
      return <span>{children}</span>;
    }

    return (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  },
};

const ChatMessageContent = memo(({ content }) => (
  <div className="message-row__text">
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      allowedElements={ALLOWED_ELEMENTS}
      unwrapDisallowed
      components={markdownComponents}
    >
      {prepareChatMarkdownForRender(content)}
    </ReactMarkdown>
  </div>
));

ChatMessageContent.displayName = "ChatMessageContent";

export default ChatMessageContent;
